import type { Injection } from '../../../types/utils';
import type { TimelineInjection } from './models';

export const TIMELINE_INJECTION: Injection<TimelineInjection> = Object.freeze({
  key: Symbol('TIMELINE_INJECTION_KEY'),
});
